import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=1e3f9920&scoped=true"
import script from "./Logout.vue?vue&type=script&lang=js"
export * from "./Logout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3f9920",
  null
  
)

export default component.exports